<template>
  <div class="mt-3 mt-md-4">
    <div
      ref="founderBody"
      class="body-section"
      :class="{'on-load': !hasParsed }"
    >
      <div class="d-none d-md-block">
        <div
          v-for="(el, index) in bodyHTML.slice(0, desktopStopLine)"
          :key="`${index}-d1`"
        >
          <div v-html="el" /> <!-- eslint-disable-line vue/no-v-html -->
        </div>
        <collapse-transition
          dimension="height"
          name="slide"
          :duration="250"
        >
          <div v-if="showMore && bodyHTML.slice(desktopStopLine).length">
            <div
              v-for="(el, index) in bodyHTML.slice(desktopStopLine)"
              :key="`${index}-d2`"
            >
              <div v-html="el" /> <!-- eslint-disable-line vue/no-v-html -->
            </div>
          </div>
        </collapse-transition>
        <a
          v-if="hasMore('desktop')"
          class="more-toggle"
          @click="clickMore"
          @keypress="clickMore"
        >
          Read {{ !showMore ? 'More' : 'Less' }}
        </a>
      </div>
      <div class="d-block d-md-none">
        <div
          v-for="(el, index) in bodyHTML.slice(0, mobileStopLine)"
          :key="`${index}-m1`"
        >
          <div v-html="el" /> <!-- eslint-disable-line vue/no-v-html -->
        </div>
        <collapse-transition
          dimension="height"
          name="slide"
          :duration="250"
        >
          <div v-if="showMore && bodyHTML.slice(mobileStopLine).length">
            <div
              v-for="(el, index) in bodyHTML.slice(mobileStopLine)"
              :key="`${index}-m2`"
            >
              <div v-html="el" /> <!-- eslint-disable-line vue/no-v-html -->
            </div>
          </div>
        </collapse-transition>
        <a
          v-if="hasMore('mobile')"
          class="more-toggle"
          @click="clickMore"
          @keypress="clickMore"
        >
          Read {{ !showMore ? 'More' : 'Less' }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

export default {
  components: {
    CollapseTransition,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bodyHTML: [],
      desktopStopLine: 1000, // Show all initially
      mobileStopLine: 1000,
      showMore: false,
      isOpen: false,
      hasParsed: false,
    };
  },
  watch: {
    text() {
      if (process.client) {
        this.parseBody();
      }
    },
  },

  mounted() {
    this.parseBody();
    this.$nextTick(() => {
      this.calcHeight();
    });
  },
  methods: {
    parseBody() {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.text;
      const parts = tempDiv.children || [];

      const bodyHTML = [];
      for (let i = 0; i < parts.length; i += 1) {
        bodyHTML.push(parts[i].outerHTML);
      }
      this.bodyHTML = bodyHTML;
    },
    hasMore(type) {
      const { length } = this.bodyHTML;
      const stopLine = (type === 'desktop') ? this.desktopStopLine : this.mobileStopLine;

      return length - stopLine > 0;
    },
    clickMore() {
      this.showMore = !this.showMore;
    },
    calcHeight() {
      const MAX_HEIGHT_DESKTOP = 400;
      const MAX_HEIGHT_MOBILE = 200;

      // Can get more fancy if we want to check for window width and window resize
      const childrenDesktop = get(this, ['$refs', 'founderBody', 'children', 0], {});
      const childrenMobile = get(this, ['$refs', 'founderBody', 'children', 1], {});

      const children = childrenDesktop.clientHeight
        ? childrenDesktop.children
        : childrenMobile.children;

      if (!(children && children.length)) return;

      let currentHeight = 0;
      let desktopStopLine = 1;
      let mobileStopLine = 1;

      for (let i = 0; i < children.length; i += 1) {
        let continueLoop = false;

        currentHeight += children[i].scrollHeight;

        if (currentHeight <= MAX_HEIGHT_DESKTOP) {
          continueLoop = true;
          desktopStopLine += 1;
        }

        if (currentHeight <= MAX_HEIGHT_MOBILE) {
          continueLoop = true;
          mobileStopLine += 1;
        }

        if (!continueLoop) {
          break;
        }
      }

      this.desktopStopLine = desktopStopLine;
      this.mobileStopLine = mobileStopLine;

      // Make sure data has been updated before removing temp hidden style
      this.$nextTick(() => {
        this.hasParsed = true;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  @import '~/styles/dorado/main'; // TODO -- Remove once auto imported

  .body-section.on-load { // While calculating section height, hide extra content
    max-height: 400px;
    overflow: hidden;
  }

  .body-section ::v-deep {
    a {
      text-decoration: none !important;

      &:hover {
        text-decoration: none !important;
      }
    }

    b {
      font-weight: 700;
    }
  }

  .more-toggle {
    text-decoration: underline !important;
    color: $bolt !important;
    font-size: $font-size-base;
    transition: 150ms color;

    &:hover {
      color: $deep-ocean !important;
      text-decoration: underline !important;
    }
  }

  @media screen and (max-width: 767px) {
    .body-section.on-load { // While calculating section height, hide extra content
      max-height: 250px;
      overflow: hidden;
    }
  }
</style>
